import React, { useEffect, useState } from "react";
import logo from "../../assets/Logo/hisabakLogoWhite.svg";
import applogo from "../../assets/Logo/apphisabakLogoWhite.png";
import plus_button from "../../assets/sidebar/plus_button.svg";
import minus_button from "../../assets/sidebar/minus_button.svg";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getSideBarData,
  logButtonClick,
} from "../../API  Functions/DashboardFunctions";

// icons
import pos from "../../assets/sidebar/pos1.svg";
import pos_blue from "../../assets/sidebar/pos_blue.svg";
import setting from "../../assets/sidebar/Settings1.svg";
import settingblue from "../../assets/sidebar/settingblue.svg";
import purchase from "../../assets/sidebar/purchase.svg";
import purchaseblue from "../../assets/sidebar/purchaseblue.svg";
import dashboard from "../../assets/sidebar/dashboard1.svg";
import dashboardblue from "../../assets/sidebar/dashboardblue1.svg";
import invent from "../../assets/sidebar/invent1.svg";
import inventoryblue from "../../assets/sidebar/inventoryblue1.svg";
import order from "../../assets/sidebar/order1.svg";
import orderblue from "../../assets/sidebar/orderblue.svg";
import payment_settlement_icon from "../../assets/sidebar/payment_settlement_icon.svg";
import payment_settlement_icon_blue from "../../assets/sidebar/payment_settlement_icon_blue.svg";
import Inter_store_transfer from "../../assets/sidebar/Inter_store_transfer.svg";
import Inter_store_transfer_blue from "../../assets/sidebar/Inter_store_transfer_blue.svg";
import cashback from "../../assets/cashback/cashback.svg";
import cashback_blue from "../../assets/cashback/total_cashback.svg";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import accounting from "../../assets/sidebar/accounting.svg";
import accounting_blue from "../../assets/sidebar/accounting_blue.svg";
import { setPermissions } from "../../Redux/Action/permissionsActions";
import {
  setContractType,
  setIsMasterStore,
  setSubscriptionEndDate,
} from "../../Redux/Action/loginAction";

const iconMap = {
  dashboard: { default: dashboard, active: dashboardblue },
  inventory: { default: invent, active: inventoryblue },
  purchase: { default: purchase, active: purchaseblue },
  cashier: { default: pos, active: pos_blue },
  e_orders: { default: order, active: orderblue },
  settings: { default: setting, active: settingblue },
  payment_report: {
    default: payment_settlement_icon,
    active: payment_settlement_icon_blue,
  },
  inter_store_transfer: {
    default: Inter_store_transfer,
    active: Inter_store_transfer_blue,
  },
  cashback: { default: cashback, active: cashback_blue },
  accounting: { default: accounting, active: accounting_blue },
};

const Sidebar = ({ mobileOpen = false, onMobileClose = () => {} }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const dispatch = useDispatch();

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const is_retailer = useSelector(
    (state) => state?.login?.user?.result?.is_retailer,
  );
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const master_store = useSelector(
    (state) => state?.login?.user?.result?.is_master_store,
  );
  const masterStore = useSelector((state) => state.login.masterStore);

  const [isOpen, setIsOpen] = useState(true);
  const [menuData, setMenuData] = useState([]);
  const [activeHeading, setActiveHeading] = useState(null);
  const [activeSubheading, setActiveSubheading] = useState(null);

  useEffect(() => {
    const fetchSidebar = async () => {
      let lang = i18next.language;
      if (lang === "ar") lang = "ar_001";
      if (lang === "en") lang = "en_US";

      const resp = await getSideBarData(user_id, company_id, lang);
      const sideBarData = resp?.response;
      const contractType = resp?.contract_type;
      const subscriptionEndDate = {
        endDate: resp?.subscription_end_date,
        is_advance_payment: resp?.is_advance_payment
      }
      dispatch(setSubscriptionEndDate(subscriptionEndDate))
      // Save contract_type to local storage only if it exists
      if (contractType !== undefined && contractType !== null) {
        dispatch(setContractType(contractType));
      }
      if (sideBarData?.length) {
        const filteredData = sideBarData.filter((item) => {
          if (item.name === "Inter Store Transfer" && !master_store) {
            return false;
          }
          return true;
        });

        filteredData.sort((a, b) => a.sequence - b.sequence);
        setMenuData(filteredData);

        // set permissions
        const permissionsMap = {};
        filteredData.forEach((menu) => {
          const menuKey = String(menu.route || menu.name || "")
            .toLowerCase()
            .trim();
          if (menuKey) {
            permissionsMap[menuKey] = {
              read: !!menu.can_read,
              edit: !!menu.can_write,
            };
          }

          menu.sub_menu_list?.forEach((sub) => {
            const subKey = String(sub.route || sub.name || "")
              .toLowerCase()
              .trim();
            if (subKey) {
              permissionsMap[subKey] = {
                read: !!sub.can_read,
                edit: !!sub.can_write,
              };
            }
          });
        });

        dispatch(setPermissions(permissionsMap));

        // 🚨 Only redirect after permissions and menu set
        redirectToInitialPage(filteredData, location.state);
        // console.log("redirectToInitialPage");
      }
    };

    fetchSidebar();
  }, [user_id, company_id, master_store]);

  const toRoute = (route) => {
    if (!route) return "/";
    return route.startsWith("/") ? route : `/${route}`;
  };

  const isValidInternalRoute = (route) => {
    return (
      typeof route === "string" && route.startsWith("/") && route.trim() !== "/"
    );
  };

  const redirectToInitialPage = (menuData, routeState) => {
    if (!menuData?.length) return;

    const currentPath = window.location.pathname.toLowerCase();
    const cameFromRegister = routeState?.fromRegister === true;

    const hasAccessToCurrentRoute = menuData.some((menu) => {
      if (
        menu.route &&
        String(menu.route || "").toLowerCase() === currentPath &&
        menu.can_read
      ) {
        return true;
      }
      return menu.sub_menu_list?.some(
        (sub) =>
          sub.route &&
          String(sub.route || "").toLowerCase() === currentPath &&
          sub.can_read,
      );
    });

    if (hasAccessToCurrentRoute) return;

    // 🟢 If user came from Register → go to Subscription
    if (cameFromRegister) {
      const subscriptionItem = menuData
        .flatMap((m) => [m, ...(m.sub_menu_list || [])])
        .find(
          (item) =>
            String(item.route || "")
              .toLowerCase()
              .includes("subscription") && item.can_read,
        );

      if (subscriptionItem) {
        navigate(toRoute(subscriptionItem.route));
        return;
      }
    }

    // Normal dashboard logic
    const dashboardItem = menuData.find(
      (item) =>
        String(item.route || "")
          .toLowerCase()
          .includes("dashboard") && item.can_read,
    );

    if (dashboardItem) {
      navigate(toRoute(dashboardItem.route));
      return;
    }

    // fallback
    for (const menu of menuData) {
      if (menu.route && menu.can_read) {
        navigate(toRoute(menu.route));
        return;
      }
      for (const sub of menu.sub_menu_list || []) {
        if (sub.route && sub.can_read) {
          navigate(toRoute(sub.route));
          return;
        }
      }
    }
  };

  // 🔹 highlight based on current path
  useEffect(() => {
    menuData.forEach((menu, index) => {
      if (menu.route && menu.route === pathname) {
        setActiveHeading(index);
        setActiveSubheading(null);
      }
      menu.sub_menu_list?.forEach((sub, subIndex) => {
        if (sub.route === pathname) {
          setActiveHeading(index);
          setActiveSubheading(subIndex);
        }
      });
    });
  }, [pathname, menuData]);

  useEffect(() => {
    if (mobileOpen) {
      onMobileClose();
    }
  }, [pathname]);

  const handleHeadingClick = (index, route) => {
    if (route) {
      navigate(route);
      onMobileClose();
      return;
    }
    setActiveHeading(activeHeading === index ? null : index);
    setActiveSubheading(null);
  };

  const handleSubheadingClick = async (
    e,
    parentIndex,
    subIndex,
    route,
    name,
  ) => {
    if (subIndex === 0 && (name === "Cashier" || name == "الكاشير")) {
      e.preventDefault(); // stop default Link/navigate
      window.open(
        `${process.env.REACT_APP_POS_REDIRECT_LINK}`,
        "_blank",
        "noopener,noreferrer",
      );
      return; // prevent rest of function
    }
    if (name === "Price Checker" || name == "التحقق من السعر") {
      e.preventDefault(); // stop default Link/navigate
      window.open(route, "_blank");
      return; // prevent rest of function
    }

    setActiveSubheading(subIndex);
    navigate(route);
    onMobileClose();
    // const res = await logButtonClick(user_id, company_id, route, "sidebar");
    // if (res?.result?.is_master_store === true && !master_store && is_retailer) {
    //   console.log("LOG RES --------->", res);
    //   dispatch(setIsMasterStore(true));
    // }
  };

  return (
    <>
      {mobileOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/40 md:hidden"
          onClick={onMobileClose}
        />
      )}
      <div
        className={`sidebar hide-scrollbar fixed ${
          i18next.language === "ar" ? "right-0" : "left-0"
        } top-0 z-50 h-screen bg-primaryBlue p-[1vh] text-white shadow-md transition-transform duration-300 md:sticky md:z-20
  ${
    mobileOpen
      ? "translate-x-0"
      : i18next.language === "ar"
        ? "translate-x-full md:translate-x-0"
        : "-translate-x-full md:translate-x-0"
  }
  ${isOpen ? "w-[35vh] overflow-auto" : "w-[8vh] overflow-visible"} md:block`}
      >
        {/* Top bar with logo + toggle */}
        <div className="flex items-center justify-between mb-[3vh] mt-[10px]">
          {isOpen && (
            <img src={logo} className="h-[5vh] w-[16vh]" alt="myGINNE Logo" />
          )}
          {!isOpen && (
            <img src={applogo} className="h-[5vh] w-[5vh]" alt="myGINNE Logo" />
          )}
          <div className="flex items-center gap-2">
            <button
              className="rounded p-2 text-xl text-white hover:bg-[#FFFFFF1A] md:hidden"
              onClick={onMobileClose}
              aria-label="Close menu"
            >
              ✕
            </button>
            <button
              className="hidden rounded text-2xl md:block"
              onClick={() => setIsOpen(!isOpen)}
            >
              <div
                className={`rounded hover:bg-[#FFFFFF1A] ${
                  isOpen
                    ? "p-2"
                    : "w-8 rounded-full bg-[#f5f5f5] text-black shadow-md transition-all duration-200 hover:shadow-lg"
                }`}
              >
                {isOpen ? "«" : "»"}
              </div>
            </button>
          </div>
        </div>

        {/* Render menu */}
        {menuData.map((menu, index) => {
          const iconSet = iconMap[menu.icon] || {};
          const isActive = activeHeading === index;

          return (
            <div key={index} className="mb-[3vh]">
              <div
                className={`heading-box font-medium flex items-center justify-start
                ${isOpen ? "w-[33vh] md:w-[28vh]" : "w-[6vh]"} h-[6vh]
                ${isActive ? "bg-white" : "bg-[#FFFFFF1A]"}
                rounded-[1vh] p-[1vh] cursor-pointer
                ${isActive ? "text-primaryBlue" : ""}
                transition-all duration-300`}
                onClick={() => handleHeadingClick(index, menu.route)}
              >
                <span className="flex items-center justify-center h-[4vh] w-[4vh]">
                  <img
                    src={isActive ? iconSet.active : iconSet.default}
                    alt={menu.name}
                  />
                </span>

                {isOpen && <span className="text-sm ms-2">{t(menu.name)}</span>}

                {isOpen && !menu.route && (
                  <span className="ms-auto">
                    {isActive ? (
                      <ExpandLess sx={{ fontSize: 20 }} />
                    ) : (
                      <ExpandMore sx={{ fontSize: 20 }} />
                    )}
                  </span>
                )}
              </div>

              {/* Sub Menu */}
              {isOpen && isActive && menu.sub_menu_list?.length > 0 && (
                <ul className="bg-[#094072] list-disc w-[33vh] md:w-[28vh] text-sm rounded-b-lg overflow-hidden max-h-[48vh] transition-all duration-300 ease-in-out pb-2">
                  {menu.sub_menu_list.map((sub, subIndex) => (
                    <div
                      key={subIndex}
                      className={`cursor-pointer py-1 mt-2 rounded-s-sm
                        ${
                          activeSubheading === subIndex &&
                          activeHeading === index
                            ? "border-l-4 ps-[2.4vh] border-[#78CFEC] text-white font-medium"
                            : "ps-[3vh] text-[#B5C6D5]"
                        }`}
                    >
                      <Link to={sub.route}>
                        <li
                          className="cursor-pointer text-xs"
                          onClick={(e) =>
                            handleSubheadingClick(
                              e,
                              index,
                              subIndex,
                              sub.route,
                              sub.name,
                            )
                          }
                          style={{
                            marginLeft: i18next.language === "ar" ? "0" : "1vh",
                            marginRight:
                              i18next.language === "ar" ? "1vh" : "0",
                            marginBottom: "2px",
                            transition: "border-color 0.3s",
                          }}
                        >
                          {t(sub.name)}
                        </li>
                      </Link>
                    </div>
                  ))}
                </ul>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Sidebar;
